export default __webpack_public_path__ + "static/Leaflet_SMFS-6c701621422dfe4b38c48ee4aa0cb8ea.pdf";